import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import FormBanner from '../../FormBanner';
import Form from '../../Forms/Form';
import { colors } from '../../../styles';

const styles = css`
  position: relative;
  max-width: 100vw;
  overflow: hidden;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 700px;
    height: 700px;
    border-radius: 50%;
    background-color: ${colors.brand6Lighter};
    left: -80px;
    top: -200px;
    z-index: 1;
  }
  &::after{
    content: '';
    display: block;
    position: absolute;
    top: 60px;
    left: 0;
    width: 40%;
    height: 42%;
    background-image: url('/images/pattern-02-light.svg');
    background-repeat: repeat;
    background-position: right top;
    z-index: 2;
    @media (min-width: 992px) {
      top: 120px;
    }
  }
  .FormWrapper {
    position: relative;
    z-index: 3;
  }
`;

function ContactForm({ content, communities }) {
  const communitiesList = orderBy(communities, 'name', 'asc').map(community => ({ label: `${get(community, 'name')} - ${get(community, 'address.addressLocality')}`, value: get(community, '_id') }));
  return (
    <div className={styles}>
      <div className="FormWrapper">
        <FormBanner
          content={get(content, '[0]')}
          redirectRoute={get(content, '[0].success_route')}
          formArea={
            <Form
              formName="contactUs"
              formLabel="Contact Us"
              submitLabel="Submit"
              fields={[
                {
                  type: 'Text',
                  label: 'First Name',
                  className: 'form-col',
                  field: 'firstName',
                  required: true,
                },
                {
                  type: 'Text',
                  label: 'Last Name',
                  className: 'form-col',
                  field: 'lastName',
                  required: true,
                },
                {
                  type: 'Email',
                  label: 'Email',
                  className: 'form-col',
                  field: 'email',
                  required: true,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'Phone',
                  label: 'Phone',
                  className: 'form-col',
                  field: 'phone',
                  required: true,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'AreaSelect',
                  label: 'City Of Interest',
                  field: 'area',
                  className: 'form-col',
                  required: true,
                },
                {
                  type: 'Select',
                  label: 'Community Of Interest',
                  field: 'com',
                  className: 'form-col',
                  required: true,
                  options: communitiesList,
                },
                {
                  type: 'TextArea',
                  label: 'Comments/Questions',
                  className: 'form-col-fluid',
                  placeholder: 'How can we help you?',
                  field: 'comments',
                  required: true,
                },
              ]}
            />
          }
        />
      </div>
    </div>
  );
}


ContactForm.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

ContactForm.defaultProps = {
};

export default withData(
  {
    communities: 'all',
  },
  {
    required: {
      communities: true,
    },
  },
  )(ContactForm);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ContactForm.section.js